import { jsx as f, jsxs as E } from "react/jsx-runtime";
import * as p from "react";
import { useState as J, useEffect as Q, useId as he, useCallback as U, createElement as pe } from "react";
import { a as xe, c as N } from "./index-eoE_jzLb.js";
import { u as K } from "./index-DoOsnuB6.js";
import { P as O, c as ge } from "./index-D8UDu4KA.js";
import { c as Se, u as ye } from "./index-Dn75bnUs.js";
import { u as ve } from "./index-BZPx6jYI.js";
import { u as be } from "./index-4vbonZJj.js";
import { c as $ } from "./clsx-OuTLNxxd.js";
import { I as Z } from "./Input-DjbLk5CI.js";
import { L as _e } from "./Label-B9Ttm_DE.js";
import './Slider.css';function ee(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var te = ["PageUp", "PageDown"], ne = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], oe = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, M = "Slider", [Y, we, Ce] = Se(M), [ie] = ge(M, [
  Ce
]), [Pe, L] = ie(M), re = p.forwardRef(
  (e, t) => {
    const {
      name: r,
      min: o = 0,
      max: a = 100,
      step: l = 1,
      orientation: s = "horizontal",
      disabled: i = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: m = [o],
      value: y,
      onValueChange: n = () => {
      },
      onValueCommit: u = () => {
      },
      inverted: S = !1,
      form: P,
      ..._
    } = e, x = p.useRef(/* @__PURE__ */ new Set()), h = p.useRef(0), C = s === "horizontal" ? Ie : Re, [v = [], d] = xe({
      prop: y,
      defaultProp: m,
      onChange: (g) => {
        var I;
        (I = [...x.current][h.current]) == null || I.focus(), n(g);
      }
    }), b = p.useRef(v);
    function H(g) {
      const B = ze(v, g);
      V(g, B);
    }
    function k(g) {
      V(g, h.current);
    }
    function A() {
      const g = b.current[h.current];
      v[h.current] !== g && u(v);
    }
    function V(g, B, { commit: I } = { commit: !1 }) {
      const D = Me(l), F = ke(Math.round((g - o) / l) * l + o, D), T = ee(F, [o, a]);
      d((W = []) => {
        const z = De(W, T, B);
        if (Ne(z, c * l)) {
          h.current = z.indexOf(T);
          const q = String(z) !== String(W);
          return q && I && u(z), q ? z : W;
        } else
          return W;
      });
    }
    return /* @__PURE__ */ f(
      Pe,
      {
        scope: e.__scopeSlider,
        name: r,
        disabled: i,
        min: o,
        max: a,
        valueIndexToChangeRef: h,
        thumbs: x.current,
        values: v,
        orientation: s,
        form: P,
        children: /* @__PURE__ */ f(Y.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ f(Y.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ f(
          C,
          {
            "aria-disabled": i,
            "data-disabled": i ? "" : void 0,
            ..._,
            ref: t,
            onPointerDown: N(_.onPointerDown, () => {
              i || (b.current = v);
            }),
            min: o,
            max: a,
            inverted: S,
            onSlideStart: i ? void 0 : H,
            onSlideMove: i ? void 0 : k,
            onSlideEnd: i ? void 0 : A,
            onHomeKeyDown: () => !i && V(o, 0, { commit: !0 }),
            onEndKeyDown: () => !i && V(a, v.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: g, direction: B }) => {
              if (!i) {
                const F = te.includes(g.key) || g.shiftKey && ne.includes(g.key) ? 10 : 1, T = h.current, W = v[T], z = l * F * B;
                V(W + z, T, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
re.displayName = M;
var [se, ae] = ie(M, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Ie = p.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      dir: a,
      inverted: l,
      onSlideStart: s,
      onSlideMove: i,
      onSlideEnd: c,
      onStepKeyDown: m,
      ...y
    } = e, [n, u] = p.useState(null), S = K(t, (C) => u(C)), P = p.useRef(void 0), _ = ye(a), x = _ === "ltr", h = x && !l || !x && l;
    function R(C) {
      const v = P.current || n.getBoundingClientRect(), d = [0, v.width], H = G(d, h ? [r, o] : [o, r]);
      return P.current = v, H(C - v.left);
    }
    return /* @__PURE__ */ f(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "left" : "right",
        endEdge: h ? "right" : "left",
        direction: h ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ f(
          le,
          {
            dir: _,
            "data-orientation": "horizontal",
            ...y,
            ref: S,
            style: {
              ...y.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (C) => {
              const v = R(C.clientX);
              s == null || s(v);
            },
            onSlideMove: (C) => {
              const v = R(C.clientX);
              i == null || i(v);
            },
            onSlideEnd: () => {
              P.current = void 0, c == null || c();
            },
            onStepKeyDown: (C) => {
              const d = oe[h ? "from-left" : "from-right"].includes(C.key);
              m == null || m({ event: C, direction: d ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Re = p.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      inverted: a,
      onSlideStart: l,
      onSlideMove: s,
      onSlideEnd: i,
      onStepKeyDown: c,
      ...m
    } = e, y = p.useRef(null), n = K(t, y), u = p.useRef(void 0), S = !a;
    function P(_) {
      const x = u.current || y.current.getBoundingClientRect(), h = [0, x.height], C = G(h, S ? [o, r] : [r, o]);
      return u.current = x, C(_ - x.top);
    }
    return /* @__PURE__ */ f(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: S ? "bottom" : "top",
        endEdge: S ? "top" : "bottom",
        size: "height",
        direction: S ? 1 : -1,
        children: /* @__PURE__ */ f(
          le,
          {
            "data-orientation": "vertical",
            ...m,
            ref: n,
            style: {
              ...m.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (_) => {
              const x = P(_.clientY);
              l == null || l(x);
            },
            onSlideMove: (_) => {
              const x = P(_.clientY);
              s == null || s(x);
            },
            onSlideEnd: () => {
              u.current = void 0, i == null || i();
            },
            onStepKeyDown: (_) => {
              const h = oe[S ? "from-bottom" : "from-top"].includes(_.key);
              c == null || c({ event: _, direction: h ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), le = p.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: r,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: l,
      onHomeKeyDown: s,
      onEndKeyDown: i,
      onStepKeyDown: c,
      ...m
    } = e, y = L(M, r);
    return /* @__PURE__ */ f(
      O.span,
      {
        ...m,
        ref: t,
        onKeyDown: N(e.onKeyDown, (n) => {
          n.key === "Home" ? (s(n), n.preventDefault()) : n.key === "End" ? (i(n), n.preventDefault()) : te.concat(ne).includes(n.key) && (c(n), n.preventDefault());
        }),
        onPointerDown: N(e.onPointerDown, (n) => {
          const u = n.target;
          u.setPointerCapture(n.pointerId), n.preventDefault(), y.thumbs.has(u) ? u.focus() : o(n);
        }),
        onPointerMove: N(e.onPointerMove, (n) => {
          n.target.hasPointerCapture(n.pointerId) && a(n);
        }),
        onPointerUp: N(e.onPointerUp, (n) => {
          const u = n.target;
          u.hasPointerCapture(n.pointerId) && (u.releasePointerCapture(n.pointerId), l(n));
        })
      }
    );
  }
), ce = "SliderTrack", de = p.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = L(ce, r);
    return /* @__PURE__ */ f(
      O.span,
      {
        "data-disabled": a.disabled ? "" : void 0,
        "data-orientation": a.orientation,
        ...o,
        ref: t
      }
    );
  }
);
de.displayName = ce;
var j = "SliderRange", ue = p.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = L(j, r), l = ae(j, r), s = p.useRef(null), i = K(t, s), c = a.values.length, m = a.values.map(
      (u) => me(u, a.min, a.max)
    ), y = c > 1 ? Math.min(...m) : 0, n = 100 - Math.max(...m);
    return /* @__PURE__ */ f(
      O.span,
      {
        "data-orientation": a.orientation,
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: i,
        style: {
          ...e.style,
          [l.startEdge]: y + "%",
          [l.endEdge]: n + "%"
        }
      }
    );
  }
);
ue.displayName = j;
var X = "SliderThumb", fe = p.forwardRef(
  (e, t) => {
    const r = we(e.__scopeSlider), [o, a] = p.useState(null), l = K(t, (i) => a(i)), s = p.useMemo(
      () => o ? r().findIndex((i) => i.ref.current === o) : -1,
      [r, o]
    );
    return /* @__PURE__ */ f(Ve, { ...e, ref: l, index: s });
  }
), Ve = p.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, index: o, name: a, ...l } = e, s = L(X, r), i = ae(X, r), [c, m] = p.useState(null), y = K(t, (R) => m(R)), n = c ? s.form || !!c.closest("form") : !0, u = be(c), S = s.values[o], P = S === void 0 ? 0 : me(S, s.min, s.max), _ = He(o, s.values.length), x = u == null ? void 0 : u[i.size], h = x ? Ee(x, P, i.direction) : 0;
    return p.useEffect(() => {
      if (c)
        return s.thumbs.add(c), () => {
          s.thumbs.delete(c);
        };
    }, [c, s.thumbs]), /* @__PURE__ */ E(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [i.startEdge]: `calc(${P}% + ${h}px)`
        },
        children: [
          /* @__PURE__ */ f(Y.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ f(
            O.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || _,
              "aria-valuemin": s.min,
              "aria-valuenow": S,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...l,
              ref: y,
              style: S === void 0 ? { display: "none" } : e.style,
              onFocus: N(e.onFocus, () => {
                s.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          n && /* @__PURE__ */ f(
            Be,
            {
              name: a ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: S
            },
            o
          )
        ]
      }
    );
  }
);
fe.displayName = X;
var Be = (e) => {
  const { value: t, ...r } = e, o = p.useRef(null), a = ve(t);
  return p.useEffect(() => {
    const l = o.current, s = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(s, "value").set;
    if (a !== t && c) {
      const m = new Event("input", { bubbles: !0 });
      c.call(l, t), l.dispatchEvent(m);
    }
  }, [a, t]), /* @__PURE__ */ f("input", { style: { display: "none" }, ...r, ref: o, defaultValue: t });
};
function De(e = [], t, r) {
  const o = [...e];
  return o[r] = t, o.sort((a, l) => a - l);
}
function me(e, t, r) {
  const l = 100 / (r - t) * (e - t);
  return ee(l, [0, 100]);
}
function He(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function ze(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((a) => Math.abs(a - t)), o = Math.min(...r);
  return r.indexOf(o);
}
function Ee(e, t, r) {
  const o = e / 2, l = G([0, 50], [0, o]);
  return (o - l(t) * r) * r;
}
function We(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function Ne(e, t) {
  if (t > 0) {
    const r = We(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function G(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (r - e[0]);
  };
}
function Me(e) {
  return (String(e).split(".")[1] || "").length;
}
function ke(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
var Ae = re, Te = de, Ke = ue, $e = fe;
const Oe = "320px", Le = "600px", Fe = "1025px", Ue = "_output_1vfe5_37", Ye = "_sliderWrapper_1vfe5_55", je = "_label_1vfe5_67", Xe = "_labelContainer_1vfe5_71", Ge = "_controlsWrapper_1vfe5_76", qe = "_inputsContainer_1vfe5_83", Je = "_inputWrapper_1vfe5_90", Qe = "_sliderContainer_1vfe5_109", Ze = "_shouldShowBackground_1vfe5_115", et = "_track_1vfe5_120", tt = "_slider_1vfe5_55", nt = "_range_1vfe5_142", ot = "_thumb_1vfe5_149", it = "_noValue_1vfe5_162", rt = "_sliderInput_1vfe5_182", w = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: Oe,
  "mobile-wide": "480px",
  tablet: Le,
  "tablet-wide": "800px",
  desktop: Fe,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "size-s": "_size-s_1vfe5_32",
  output: Ue,
  "size-m": "_size-m_1vfe5_43",
  sliderWrapper: Ye,
  label: je,
  labelContainer: Xe,
  controlsWrapper: Ge,
  inputsContainer: qe,
  inputWrapper: Je,
  sliderContainer: Qe,
  shouldShowBackground: Ze,
  track: et,
  slider: tt,
  range: nt,
  thumb: ot,
  noValue: it,
  sliderInput: rt
}, gt = ({
  className: e,
  label: t,
  shouldShowBackground: r = !1,
  shouldShowLabel: o = !1,
  size: a = "m",
  unit: l,
  withInputs: s = !1,
  ...i
}) => {
  const { max: c = 1 / 0, min: m = -1 / 0, onValueChange: y } = i, [n, u] = J(i.value || i.defaultValue || [0]), [S, P] = J([]);
  Q(() => {
    i.value && u(i.value);
  }, [i.value]), Q(() => {
    P(n.map((d) => String(d)));
  }, [n]);
  const _ = n && n.length <= 1 && n[0] === 0, x = he(), h = `${x}-output`, R = U(
    (d, b) => {
      var B;
      P((I) => {
        const D = [...I];
        return D[d] = b, D;
      });
      const H = parseInt(b, 10);
      if (isNaN(H))
        return;
      const { max: k = 1 / 0, min: A = -1 / 0 } = i, V = Math.max(A, Math.min(H, k));
      if (d === 0 && V > n[1] || d === 1 && V < n[0])
        return;
      const g = [...n];
      g[d] = V, g.some((I, D) => I !== n[D]) && (u(g), (B = i.onValueChange) == null || B.call(i, g));
    },
    [m, c, y, i, n]
  ), C = U(
    (d) => {
      const b = parseInt(S[d], 10), H = n[d === 0 ? 1 : 0], k = isNaN(b), A = b < (m ?? -1 / 0), V = b > (c ?? 1 / 0), g = d === 0 && b > H || d === 1 && b < H;
      k || A || V || g ? P((I) => {
        const D = [...I];
        return D[d] = String(n[d]), D;
      }) : R(d, String(b));
    },
    [S, n, m, c, R]
  ), v = U(
    (d) => {
      u(d), y == null || y(d);
    },
    [y]
  );
  return /* @__PURE__ */ E("div", { className: $(w.sliderWrapper, w[`size-${a}`]), "data-cxy-name": "slider", children: [
    o && /* @__PURE__ */ f("div", { className: w.labelContainer, children: /* @__PURE__ */ f(_e, { className: w.label, htmlFor: x, size: "s", children: t }) }),
    /* @__PURE__ */ E("div", { className: w.controlsWrapper, children: [
      /* @__PURE__ */ E(
        "div",
        {
          className: $(w.sliderContainer, {
            [w.shouldShowBackground]: r
          }),
          children: [
            /* @__PURE__ */ E(
              Ae,
              {
                id: x,
                ...!o && { "aria-label": t },
                "aria-describedby": h,
                className: $(w.slider, e),
                ...i,
                onValueChange: v,
                value: n,
                children: [
                  /* @__PURE__ */ f(Te, { className: w.track, children: /* @__PURE__ */ f(Ke, { className: w.range }) }),
                  n.map((d, b) => /* @__PURE__ */ pe(
                    $e,
                    {
                      ...!o && { "aria-label": t },
                      className: $(w.thumb, { [w.noValue]: _ }),
                      key: `${t}-thumb-${b}`
                    }
                  ))
                ]
              }
            ),
            !s && /* @__PURE__ */ E("p", { className: w.output, "data-testid": "slider-output", id: h, children: [
              n.map((d, b) => /* @__PURE__ */ f("span", { children: `${n[b]}${b === n.length - 1 ? "" : "-"}` }, `${t}-output-${b}`)),
              l || ""
            ] })
          ]
        }
      ),
      s && n.length === 2 && /* @__PURE__ */ E("div", { className: w.inputsContainer, children: [
        /* @__PURE__ */ f("div", { className: w.inputWrapper, children: /* @__PURE__ */ f(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: n[1],
            min: m,
            onBlur: () => C(0),
            onChange: (d) => R(0, d.target.value),
            type: "number",
            value: S[0] ?? ""
          }
        ) }),
        /* @__PURE__ */ f("div", { className: w.inputWrapper, children: /* @__PURE__ */ f(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: c,
            min: n[0],
            onBlur: () => C(1),
            onChange: (d) => R(1, d.target.value),
            type: "number",
            value: S[1] ?? ""
          }
        ) })
      ] })
    ] })
  ] });
};
export {
  gt as S
};
